/* eslint-disable max-len */

import { useTranslation } from 'react-i18next';
import { CustomError, ManageCodeLabelColumn } from '../../../../components';
import { defectType } from '../../../../entityModel';
import {
  TXT_DATA_NOT_FOUND,
  TXT_DELETE,
  TXT_EDIT,
  TXT_LOADING
} from '../../../../translations/translationConstants';
import { capitalizeFirstLetter } from '../../../../shared/stringFunctions';
import { getDefectTypeOutput } from '../../../../api';
import { ApolloError } from '@apollo/client';

export interface ManageDefectTypesTableBodyProps {
  error?: ApolloError;
  loading: boolean;
  data?: getDefectTypeOutput;
  columns: ManageCodeLabelColumn[];
  onEdit: (defectType: defectType) => void;
  onDelete: (defectType: defectType) => void;
}

export const ManageDefectTypesTableBody =
  ({ error, columns, loading, data, onEdit, onDelete }: ManageDefectTypesTableBodyProps) => {
    const { t } = useTranslation();
    return (
      <tbody>
        {
          loading &&
          <tr>
            <td colSpan={columns.length} style={{ textAlign: 'center' }}>
              <h3>
                {t(TXT_LOADING).toUpperCase()}
              </h3>
            </td>
          </tr>
        }
        {
          !loading && error && error.message &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {error.message}
              </CustomError>
            </td>
          </tr>
        }
        {
          !loading && data &&
          data.defectTypes && data.defectTypes.items &&
          data.defectTypes.items.length > 0 &&
          data.defectTypes.items.map((defectType) => (
            <tr key={`row-${defectType.id}`}>
              <td>
                {defectType.code}
              </td>
              <td>
                {defectType.label}
              </td>
              <td align='center'>
                <button
                  data-target="#modal-defectType-editor"
                  data-toggle="modal"
                  className='btn btn-primary'
                  aria-label="edit defectType"
                  onClick={() => onEdit(defectType)}>
                  {t(TXT_EDIT).toUpperCase()}
                </button>
              </td>
              <td align='center'>
                <button
                  data-target="#modal-default"
                  data-toggle="modal"
                  className='btn btn-danger'
                  aria-label="delete defectType"
                  type="button"
                  onClick={() => onDelete(defectType)}>
                  {t(TXT_DELETE).toUpperCase()}
                </button>
              </td>
            </tr>
          ))
        }
        {
          !loading &&
          (!data ||
            !data.defectTypes ||
            !data.defectTypes.items ||
            data.defectTypes.items.length <= 0) &&
          <tr>
            <td colSpan={columns.length}>
              <CustomError>
                {capitalizeFirstLetter(t(TXT_DATA_NOT_FOUND))}
              </CustomError>
            </td>
          </tr>
        }
      </tbody>
    );
  };
